/** Chart.js-style data from dashboard stats APIs (payments, subscriptions) */
export interface ChartDataProps {
    labels?: string[]
    datasets?: Record<string, unknown>[]
}

export const chartColorVariants = [
    'primary',
    'warning',
    'danger',
    'success',
    'info',
    'dark',
    'secondary',
]
